import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onSelect", "value", "onFocus", "onBlur", "emptyText", "testName", "onChange", "onChangeOptions", "options", "debounceInterval", "onError", "onSearch", "activeOption"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { memo, useCallback, useMemo, useRef, useState } from 'react';
import classnames from 'classnames/bind';
import { debounce } from 'debounce';
import { Input } from "../Input";
import { DropdownList } from "../../Dropdown/components/DropdownList";
import { SearchIcon } from "../../icons";
import styles from "./styles.pcss";
var cx = classnames.bind(styles);

/* toDo: сделать переезд компонента на новый DropdownList */
export var StatelessSearchInput = /*#__PURE__*/memo(function (_ref) {
  var onSelect = _ref.onSelect,
    value = _ref.value,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    _ref$emptyText = _ref.emptyText,
    emptyText = _ref$emptyText === void 0 ? 'По вашему запросу ничего не найдено' : _ref$emptyText,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'SearchInput' : _ref$testName,
    onChange = _ref.onChange,
    onChangeOptions = _ref.onChangeOptions,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$debounceInterval = _ref.debounceInterval,
    debounceInterval = _ref$debounceInterval === void 0 ? 300 : _ref$debounceInterval,
    onError = _ref.onError,
    onSearch = _ref.onSearch,
    activeOption = _ref.activeOption,
    inputProps = _objectWithoutProperties(_ref, _excluded);
  var skipResults = useRef(false);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setLoading = _useState4[1];
  var handleFocus = function handleFocus(event) {
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    setFocused(true);
  };
  var handleOnBlur = function handleOnBlur(event) {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    setFocused(false);
  };

  /* если у нас в списке у возвращаемого ответа нет ссылок, значит мы
  при клике на каждый из элементов дропдауна не хотим перехода и остаемся на месте,
  поэтому название кликнутого элемента из дропдауна будем выводить в сам инпут как вариант нашего выбора
  */
  var handleOptionClicked = useCallback(function (option) {
    if (!options.find(function (optionElem) {
      return optionElem.href;
    })) {
      onChange === null || onChange === void 0 ? void 0 : onChange(option.label || '');
    }
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(option);
  }, [onSelect, options]);
  var handleSearchEvent = useMemo(function () {
    return debounce( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!skipResults.current) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              setLoading === null || setLoading === void 0 ? void 0 : setLoading(true);
              _context.prev = 3;
              _context.next = 6;
              return onSearch(query);
            case 6:
              result = _context.sent;
              if (!skipResults.current) {
                _context.next = 9;
                break;
              }
              return _context.abrupt("return");
            case 9:
              onChangeOptions === null || onChangeOptions === void 0 ? void 0 : onChangeOptions(result);
              _context.next = 16;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);
              onError === null || onError === void 0 ? void 0 : onError(_context.t0);
              onChangeOptions === null || onChangeOptions === void 0 ? void 0 : onChangeOptions([]);
            case 16:
              _context.prev = 16;
              setLoading(false);
              return _context.finish(16);
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 12, 16, 19]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), debounceInterval);
  }, [onSearch, onError, setLoading, debounceInterval]);
  var handleChange = function handleChange(event) {
    var nextValue = event ? event.target.value.trimStart() : '';
    onChange === null || onChange === void 0 ? void 0 : onChange(nextValue);
    if (nextValue) {
      // eslint-disable-next-line no-void
      void handleSearchEvent(nextValue);
      skipResults.current = false;
      return;
    }
    skipResults.current = true;
    onChangeOptions === null || onChangeOptions === void 0 ? void 0 : onChangeOptions([]);
    setLoading(false);
  };
  return /*#__PURE__*/React.createElement(Input, _extends({
    autoComplete: "off",
    leftAside: /*#__PURE__*/React.createElement("span", {
      className: cx('search-icon')
    }, /*#__PURE__*/React.createElement(SearchIcon, {
      size: "s"
    })),
    testName: testName,
    type: "text"
  }, inputProps, {
    bottomLayoutNode: options.length || isLoading || focused ? /*#__PURE__*/React.createElement("div", {
      className: cx('dropdown', {
        'dropdown--hidden': !focused || !value && !options.length
      })
    }, /*#__PURE__*/React.createElement(DropdownList, {
      activeOption: activeOption,
      emptyText: value ? emptyText : undefined,
      onOptionClicked: handleOptionClicked,
      options: options || [],
      pending: isLoading
    })) : undefined,
    onBlur: handleOnBlur,
    onChange: handleChange,
    onClear: function onClear() {
      return handleChange();
    },
    onFocus: handleFocus,
    value: value,
    "data-t-id": "inputs-SearchInput"
  }));
});